/* This entire file is taken from the mobile app code to re-use the same encryption logic for generating encrypted file */

import AES from "crypto-js/aes";

const KEY = "8cc44c04f1b3fd0ce243a84e709027e0";

function encrypt(value: any): any {
    return AES.encrypt(value, KEY);
}

export function encryptEntry(objectToEncrypt: any, arrayToEncrypt = [] as any, keyNameForArray = ""): any {
    let encryptedObject = {} as any;
    const jsonEncodedKeys = new Set([
        "tabContentImages",
        "tabImages",
        "resources",
        "resourceLinks",
        "tabAttachedResources",
        "resourceFiles"
    ]);

    for (const key in objectToEncrypt) {
        if (key !== keyNameForArray) {
            console.log(key);
            if (jsonEncodedKeys.has(key)) {
                console.log("encrypting" + key + " array");
                const encryptyedValue = encrypt(JSON.stringify(objectToEncrypt[key])).toString();
                encryptedObject = { ...encryptedObject, [encrypt(key).toString()]: encryptyedValue };
            } else if (key !== "id" && key !== "journeySetId" && key !== "quadrantId" && key !== "js89sd8lsDKf3" && key !== 'locale') {
                if (objectToEncrypt[key]) {
                    const encryptyedValue = encrypt(objectToEncrypt[key].toString()).toString();
                    encryptedObject = { ...encryptedObject, [encrypt(key).toString()]: encryptyedValue };
                }
            } else {
                encryptedObject = { ...encryptedObject, [key]: objectToEncrypt[key] };
            }
        }
    }

    if (arrayToEncrypt.length > 0) {
        let encryptedArray = [] as any;
        for (const currentTab of arrayToEncrypt) {
            let encryptedObjectForArray = {};
            for (const key in currentTab) {
                if (currentTab[key]) {
                    const valueToEncrypt = jsonEncodedKeys.has(key)
                        ? JSON.stringify(currentTab[key])
                        : currentTab[key].toString();
                    const encryptyedValue = encrypt(valueToEncrypt).toString();
                    encryptedObjectForArray = { ...encryptedObjectForArray, [encrypt(key).toString()]: encryptyedValue };
                }
            }
            encryptedArray = [encryptedObjectForArray, ...encryptedArray];
        }
        encryptedObject = { ...encryptedObject, [keyNameForArray]: encryptedArray };
    }
    return encryptedObject;
}